import { render } from "./ViewCommande.vue?vue&type=template&id=2b9cf52c&ts=true"
import script from "./ViewCommande.vue?vue&type=script&lang=ts"
export * from "./ViewCommande.vue?vue&type=script&lang=ts"

import "./ViewCommande.vue?vue&type=style&index=0&id=2b9cf52c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__